import { Trans, useTranslation } from 'react-i18next';
import { Requirements } from './components/Requirements';
import { ScVipTransfer } from './styled';

const BENEFITS_STEP = '02';

export const VipTransfer = () => {
  const { t } = useTranslation('vip');
  return (
    <ScVipTransfer>
      <div className="transfer-wrapper">
        <span className="title">
          <Trans
            components={{
              s: <span className="step" />,
            }}
            i18nKey={'steps.vipTransfer.title'}
            t={t}
            values={{ value: BENEFITS_STEP }}
          />
        </span>
        <span className="description">
          {t('steps.vipTransfer.description')}
        </span>
      </div>
      <Requirements />
    </ScVipTransfer>
  );
};
